#import "../fragments/bulk-edit-fragment.graphql"

query GetBulkEdits($first: Int, $after: String) {
    bulkEdits(first: $first, after: $after) {
        totalCount
        pageInfo {
            startCursor
            endCursor
            hasNextPage
            hasPreviousPage
        }
        edges {
            node {
                ...BulkEditFragment
            }
        }
    }
}
